module.exports = __webpack_public_path__ + "static/media/clip.493a4604.svg";